import { Table, Toggle } from "rsuite";
const { Cell } = Table;

const EditCell = ({
  rowData,
  dataKey,
  onChange,
  ...props
}: {
  rowData?: any;
  dataKey?: any;
  onChange: Function;
}) => {
  const editing = rowData.editStatus === "EDIT";
  return (
    <Cell {...props} className={editing ? "table-content-editing" : ""}>
      {(() => {
        if (editing && dataKey == "status")
          return (
            <Toggle
              defaultChecked={rowData[dataKey]}
              onChange={(value: any) => {
                onChange && onChange(rowData.id, dataKey, value);
              }}
            />
          );
        else if (editing && dataKey != "status")
          return (
            <input
              className="rs-input"
              defaultValue={rowData[dataKey]}
              onChange={(event: any) => {
                onChange && onChange(rowData.id, dataKey, event.target.value);
              }}
            />
          );
        else if (dataKey == "status")
          return (
            <span className="table-content-edit-span">
              {rowData[dataKey] == "1" ? "Active" : "Inactive"}
            </span>
          );
        else
          return (
            <span className="table-content-edit-span">{rowData[dataKey]}</span>
          );
      })()}
    </Cell>
  );
};

export default EditCell;
